import { useEffect, useRef } from 'react';

export const useOutsideClick = (onOutsideClick, disableOutsideClick?: boolean) => {
  const elementRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        elementRef.current &&
        !elementRef.current.contains(event.target) &&
        !disableOutsideClick
      ) {
        onOutsideClick();
      }
    };
    document.addEventListener('mousedown', handleOutsideClick);
    document.addEventListener('touchend', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
      document.removeEventListener('touchend', handleOutsideClick);
    };
  }, [disableOutsideClick, elementRef, onOutsideClick]);

  return elementRef;
};
